import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import EstoqueParceiro from "../classes/EstoqueParceiro";
import Parceiro from "../classes/Parceiro";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "EstoqueParceiro/All/RecuperarPorFiltro" },
  { method: "POST", rota: "EstoqueParceiro/Adicionar" },
  { method: "PUT", rota: "EstoqueParceiro/Atualizar" },
  { method: "DELETE", rota: "EstoqueParceiro/Apagar" },
];

const cacheKey: string = "estoqueParceiroCache";
const cacheKeySelC: string = "estoqueParceiroSelecionado";

const apiServico: string = "PEDIDOS";

export default class EstoqueParceiroDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(centro: string): Promise<EstoqueParceiro[]> {
    let ok: boolean = false;
    let data: EstoqueParceiro[] = [];
    let error: any = undefined;
    let url = `${calls[0].rota}?centro=${centro}`;
    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        data = EstoqueParceiro.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<EstoqueParceiro[]>((resolve) => {
      resolve(data);
    });
  }

  async add(value: EstoqueParceiro) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async update(value: EstoqueParceiro): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[2].rota, EstoqueParceiro.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  async remove(value: EstoqueParceiro): Promise<boolean> {
    let ok: boolean = false;
    let error: any = undefined;
    await super
      .delete(calls[3].rota, EstoqueParceiro.toJson(value))
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<boolean>((resolve) => {
      resolve(ok);
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): EstoqueParceiro[] {
    let result: EstoqueParceiro[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: EstoqueParceiro[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
